import React from 'react';
import { Filter, User2, Calendar } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { UserFilter } from '../../../components/dashboard/types/dashboardTypes';

interface EmptyTaskStateProps {
  showUnscheduledOnly?: boolean;
  showUnassignedOnly?: boolean;
  userFilters?: UserFilter[];
  isMobile?: boolean;
  className?: string;
}

export function EmptyTaskState({
  showUnscheduledOnly,
  showUnassignedOnly,
  userFilters,
  isMobile = false,
  className,
}: EmptyTaskStateProps) {
  // Helper to get active user filter, if any
  const activeUserFilter = userFilters?.find(f => f.active);
  
  // Determine the appropriate message based on filter configuration
  const getMessage = () => {
    // Check if any filters are active
    const isAnyFilterActive = showUnscheduledOnly || showUnassignedOnly || activeUserFilter;
    
    if (showUnscheduledOnly) {
      return {
        icon: <Calendar size={isMobile ? 18 : 20} className="text-gray-300" />,
        description: 'No unscheduled tasks',
      };
    } 
    
    if (showUnassignedOnly) {
      return {
        icon: <User2 size={isMobile ? 18 : 20} className="text-gray-300" />,
        description: 'No unassigned tasks',
      };
    }
    
    if (activeUserFilter) {
      return {
        icon: <User2 size={isMobile ? 18 : 20} className="text-gray-300" />,
        description: `No tasks assigned to ${activeUserFilter.name}`,
      };
    }
    
    // If no filters are active, show a generic message
    if (!isAnyFilterActive) {
      return {
        icon: <Filter size={isMobile ? 18 : 20} className="text-gray-300" />,
        description: 'No tasks',
      };
    }
    
    // Only show "No tasks match your filters" when filters are actually active
    return {
      icon: <Filter size={isMobile ? 18 : 20} className="text-gray-300" />,
      description: 'No tasks match your filters',
    };
  };
  
  const message = getMessage();
  
  return (
    <div className={cn(
      'flex flex-col items-center justify-center text-center',
      isMobile ? 'pt-2 pb-6 px-4' : 'pt-4 pb-8',
      className
    )}>
      <div className="mb-2">{message.icon}</div>
      <p className={cn(
        'text-gray-300 px-8',
        isMobile ? 'text-xs' : 'text-sm'
      )}>
        {message.description}
      </p>
    </div>
  );
}